import { MathJax } from "better-react-mathjax"
import parse from "html-react-parser"
import * as React from "react"

export const convertMessage = (message: string) => {
  const parsedText = parse(message)

  const openLinkInNewTab = (e: Event, link: string) => {
    e.stopPropagation()
    const targetWindow: Window | null = window.open(link, "_blank")

    return targetWindow
  }

  let updatedText = null

  const parsedTextArray = Array.isArray(parsedText) ? parsedText : [parsedText]

  updatedText = parsedTextArray.map((element, index) => {
    if (typeof element === "string") {
      return element
    }
    if (element.type === "a") {
      return React.cloneElement(element, {
        onTouchEnd: (e: TouchEvent) =>
          openLinkInNewTab(e, element.props.children),
        onClick: (e: PointerEvent) =>
          openLinkInNewTab(e, element.props.children)
      })
    } else if (element.type === "mathjax") {
      return React.createElement(
        MathJax,
        { inline: true },
        `\\(${element.props.children}\\)`
      )
    } else if (element.type.includes("function")) {
      return ""
    } else {
      return ""
    }
    return element
  })

  return updatedText
}
